module.exports = __webpack_public_path__ + "img/monterey_crank.e2364d3b.jpg";